import { SVGProps } from "react";

const AISuggestion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.66406 0.517578C7.66406 0.517578 8.8729 3.77323 10.3912 5.29131C11.9091 6.80909 15.1641 8.01758 15.1641 8.01758C15.1641 8.01758 11.9092 9.22732 10.3912 10.7455C8.87346 12.2633 7.66406 15.5176 7.66406 15.5176C7.66406 15.5176 6.45466 12.2633 4.93697 10.7455C3.41897 9.22732 0.164063 8.01758 0.164063 8.01758C0.164063 8.01758 3.41903 6.80909 4.93697 5.29131C6.45523 3.77323 7.66406 0.517578 7.66406 0.517578Z"
      fill="url(#paint0_linear_19626_61298)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_19626_61298"
        x1={4.33055}
        y1={2.60051}
        x2={10.1628}
        y2={15.5147}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#003890" />
        <stop offset={1} stopColor="#E43820" />
      </linearGradient>
    </defs>
  </svg>
);
export default AISuggestion;
